import { useState } from "react";
import { PageLayout } from "@/components/PageLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CalculatorSuperCalcCTA } from "@/components/CalculatorSuperCalcCTA";
import { calculatorCTAs } from "@/data/calculatorCTAs";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Calculator } from "lucide-react";
import { toast } from "sonner";
import { CopyResultButton } from "@/components/CopyResultButton";

export default function DiffractionGratingCalculator() {
  const [d, setD] = useState("");
  const [order, setOrder] = useState("1");
  const [angle, setAngle] = useState("");
  const [result, setResult] = useState<number | null>(null);

  const calculate = () => {
    const spacing = parseFloat(d);
    const m = parseFloat(order);
    const theta = parseFloat(angle) * Math.PI / 180;
    if (isNaN(spacing) || isNaN(m) || isNaN(theta)) {
      toast.error("Enter valid values");
      return;
    }
    const lambda = (spacing * Math.sin(theta)) / m;
    setResult(lambda * 1e9);
    toast.success("Complete!");
  };

  return (
    <PageLayout calculatorName="Diffraction Grating Calculator" calculatorPath="/calculator/diffraction-grating">
      <div className="max-w-2xl mx-auto">
        <Card>
          <CardHeader><CardTitle>dsinθ = mλ</CardTitle></CardHeader>
          <CardContent className="space-y-4">
            <div><Label>Grating Spacing d (m)</Label><Input type="number" step="any" placeholder="e.g., 1e-6" value={d} onChange={(e) => setD(e.target.value)} /></div>
            <div><Label>Order m</Label><Input type="number" value={order} onChange={(e) => setOrder(e.target.value)} /></div>
            <div><Label>Angle θ (°)</Label><Input type="number" value={angle} onChange={(e) => setAngle(e.target.value)} /></div>
            <Button onClick={calculate} className="w-full"><Calculator className="mr-2 h-4 w-4" />Calculate</Button>
            {result !== null && (
              <>
                <Card className="bg-primary/10 p-4">
                  <div className="flex items-start justify-between gap-4">
                    <div className="min-w-0 flex-1">
                      <p className="text-2xl font-bold break-all overflow-wrap-anywhere">{result.toFixed(2)} nm</p>
                      <p className="text-sm">Wavelength</p>
                    </div>
                    <CopyResultButton value={`${result.toFixed(2)} nm`} />
                  </div>
                </Card>
                
                <CalculatorSuperCalcCTA config={calculatorCTAs["diffraction-grating"]} trigger={result} />
              </>
            )}
          </CardContent>
        </Card>
      </div>
    </PageLayout>
  );
}
